import styled, { css } from 'styled-components';
import { position } from 'styled-system';
import { motion } from 'motion/react';
import breakpoint from '../../utils/style-utils';
import { IconHalfCircleLeanLeft, IconHalfCircleLeanRight } from '../icons/icons.js';

const dataAt = props => ({
	'data-at': props.dataAt
});

export const SliderArrowStyle = {
	embedded: 'embedded',
	covering: 'covering'
};

const ArrowLeft = styled(IconHalfCircleLeanLeft).attrs(dataAt)`
	--browse-circle-bg: var(--main-background-sidebar);
	position: absolute;
	cursor: pointer;
	display: flex;
	opacity: ${props => (props.show ? '1' : '0')};
	transition: opacity 300ms ease-out;
	transform: translate3d(0, -50%, 0);
	${props => {
		if (props.arrowStyle === SliderArrowStyle.covering) {
			return css`
				left: -24px;
				width: 48px;
				border-radius: 50%;

				& svg {
					transform: translateX(-2px);
				}
				& img {
					transform: translateX(-2px);
				}
			`;
		}

		return css`
			${props.withinSidebar
				? css`
						left: 0;
						${breakpoint.lg`
						left: auto;
						right: var(--detailWidth);
						transform: translate3d(100%, -60%, 0);
						`}
					`
				: css`
						left: 0;
					`}

			& svg {
				transform: translateX(-6px);
			}
			& img {
				transform: translateX(-6px);
			}
		`;
	}}

	${props => {
		if (props.arrowStyle === SliderArrowStyle.covering) {
			return css`
				& svg {
					transform: translateX(-2px);
				}
				& img {
					transform: translateX(-2px);
				}
			`;
		}

		return css`
			& svg {
				transform: translateX(-6px);
			}
			& img {
				transform: translateX(-6px);
			}
		`;
	}}

	top: '50%';
	${position}
`;

const ArrowRight = styled(IconHalfCircleLeanRight).attrs(dataAt)`
	--browse-circle-bg: var(--main-background-sidebar);
	position: absolute;
	cursor: pointer;
	display: flex;
	opacity: ${props => (props.show ? '1' : '0')};
	transition: opacity 300ms ease-out;
	transform: translate3d(0, -50%, 0);

	${props => {
		if (props.arrowStyle === SliderArrowStyle.covering) {
			return css`
				right: -24px;
				width: 48px;
				border-radius: 50%;

				& svg {
					transform: translateX(2px);
				}
				& img {
					transform: translateX(2px);
				}
			`;
		}

		return css`
			right: 0;

			& svg {
				transform: translateX(6px);
			}
			& img {
				transform: translateX(6px);
			}
		`;
	}}

	top: '50%';
	${position}
`;

const Slider = styled.div`
	width: 100%;
	position: relative;
	height: 100%;
	flex: 1;
`;

const MotionSlider = styled(motion.div)`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	overflow: visible;
	overflow-x: hidden;
	position: absolute;
`;

const Item = styled.div`
	height: 100%;
	position: absolute;
	overflow: hidden;
	transition: opacity 300ms ease-out;
	width: ${({ itemWidth }) => `${itemWidth}px`};
	flex: 1;
	&:not(:last-child) {
		padding-right: 12px;
	}
`;

const SingleItemWrapper = styled(Item)`
	left: 50%;
	transform: translateX(-50%);
`;

const SlideItemWrapper = motion(Item);

export { ArrowLeft, ArrowRight, Slider, MotionSlider, SingleItemWrapper, SlideItemWrapper };
